// Shubham code
import React, { useEffect, useState } from "react";
import HRNavbar from "../../../HR/HRNavbar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

import {
  useMediaQuery,
  CircularProgress,
  TextField,
  Button,
  AppBar,
  InputBase,
  Menu,
  MenuItem,
  Modal,
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableContainer,
  TablePagination,
  Tooltip,
  IconButton,
  TableCell,
  Chip,
} from "@mui/material";
import { styled } from "@mui/system";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ViewPayouReportsModal from "./ViewPayouReportsModal";
import Footer from "../../../../Footer";
import { GridCheckCircleIcon, GridCloseIcon } from "@mui/x-data-grid";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { API_URL } from "../../../Config/api";
const customStyles = {
  "& .Mui-focused": {
    outline: "none",
  },
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  pt: 2,
  px: 4,
  pb: 3,
};
const OngoingServiceCard = styled(Card)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "10px",
  backgroundColor: "white",
  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
  height: "3rem",
  borderRadius: "10px",
  transition: "0.5s ease-in-out",
  "&:hover": {
    backgroundColor: "#F7F7F7",
    cursor: "pointer",
    borderLeft: "4px solid #A5D6A7",
    borderRight: "4px solid #A5D6A7",
  },
});

const filterBoxStyle = {
  p: "2px 4px",
  display: "flex",
  alignItems: "center",
  width: 200,
  height: "2.5rem",
  backgroundColor: "#ffffff",
  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
  borderRadius: "10px",
  border: "1px solid #C9C9C9",
};

const PaymentpayoutReport = () => {
  const accessToken = localStorage.getItem("token");

  const [isSmallScreen, setIsSmallScreen] = useState(false); // Mock for screen size
  const [loading, setLoading] = useState(false);
  const [onServices, setOnServices] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tableHeight, setTableHeight] = useState("auto");

  const [eventID, setEventID] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedService, setSelectedService] = useState("");

  const [openViewModal, setOpenViewModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [selectedProfessional, setSelectedProfessional] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");

  const [modalData, setModalData] = useState(null);
  // success | error | warning | info

  console.log("eventID", eventID);

  const filteredData = onServices.filter((item) => {
    // future search / date filter logic
    return true;
  });

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  // ************** API Integration **********************************************

  useEffect(() => {
    // Set screen size state dynamically
    const handleResize = () => setIsSmallScreen(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    handleResize(); // Initial call
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  

  // *****************************************************************************

 const handleSubmit = async () => {
   // Service selection agar zaroori nahi hai toh usey condition se hata sakte hain
   if (!fromDate || !toDate) {
     setSnackbarMsg("Please select both dates");
     setSnackbarType("warning");
     setSnackbarOpen(true);
     return;
   }

   try {
     setLoading(true);
     // Updated API URL for Transaction Report
     const response = await axios.get(
       `${API_URL}/pay_out/payout_get_transection_report/`,
       {
         params: {
           start_date: fromDate,
           end_date: toDate,
         },
         headers: {
           Authorization: `Bearer ${accessToken}`,
         },
       },
     );

     setOnServices(response.data); // Table data set karega
     setIsFiltered(true);
     setPage(0);
   } catch (error) {
     setSnackbarMsg("Failed to fetch transaction report");
     setSnackbarType("error");
     setSnackbarOpen(true);
   } finally {
     setLoading(false);
   }
 };

  const handleReset = () => {
    setFromDate("");
    setToDate("");
    setSelectedService("");
    setSelectedProfessional("");
    
    setIsFiltered(false);

    setSnackbarMsg("Filters reset successfully");
    setSnackbarType("info");
    setSnackbarOpen(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    const setDynamicHeight = () => {
      const screenHeight = window.innerHeight;
      var tableContainerHeight =
        screenHeight - setTableHeight(tableContainerHeight + "px");
    };
    setDynamicHeight();
    window.addEventListener("resize", setDynamicHeight);
    return () => {
      window.removeEventListener("resize", setDynamicHeight);
    };
  }, []);

const handleView = async (row) => {
  try {
    setLoading(true);
   
    const response = await axios.get(
      `${API_URL}/pay_out/prof_payout_report_get_request_api/${row.pay_req_id}/`,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    );

    setModalData(response.data); 
    setOpenViewModal(true);
  } catch (error) {
    setSnackbarMsg("Failed to fetch details");
    setSnackbarType("error");
    setSnackbarOpen(true);
  } finally {
    setLoading(false);
  }
};

  const handleCloseViewModal = () => {
    handleSubmit(); // Refresh data when modal closes
    setOpenViewModal(false);
    setSelectedRow(null);
  };


const handleDownloadExcel = async () => {
  if (!fromDate || !toDate) {
    setSnackbarMsg("Please select Start and End date first");
    setSnackbarType("warning");
    setSnackbarOpen(true);
    return;
  }

  

  const api = `${API_URL}/pay_out/payout_report_excel/?start_date=${fromDate}&end_date=${toDate}`;

  setLoading(true); 

  try {
    const response = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`, 
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) throw new Error("Download failed");

 
    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);

  
    const a = document.createElement("a");
    a.href = url;
    a.download = `Payout_Report_${fromDate}_to_${toDate}.xlsx`; 
    document.body.appendChild(a);
    a.click();

    // Cleanup
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    setSnackbarMsg("Excel Downloaded successfully!");
    setSnackbarType("success");
    setSnackbarOpen(true);
  } catch (error) {
    console.error("Error:", error);
    setSnackbarMsg("Failed to download Excel. Try again.");
    setSnackbarType("error");
    setSnackbarOpen(true);
  } finally {
    setLoading(false);
  }
};
  return (
    <>
      <HRNavbar />
      <Box sx={{ flexGrow: 1, mt: 14.6, ml: 1, mr: 1, mb: 3 }}>
       <Stack
  direction={isSmallScreen ? "column" : "row"}
  spacing={2}
  sx={{ mb: 1 }} 
  alignItems="center"
>
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: "#205964", mr: 2 }}
          >
            PAYOUT REPORTS
          </Typography>

          <Box sx={filterBoxStyle}>
            <Typography variant="caption" sx={{ mr: 1, color: "gray" }}>
              From:
            </Typography>
            <InputBase
              type="date"
              fullWidth
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Box>

          <Box sx={filterBoxStyle}>
            <Typography variant="caption" sx={{ mr: 1, color: "gray" }}>
              To:
            </Typography>
            <InputBase
              type="date"
              fullWidth
              value={toDate}
              inputProps={{ min: fromDate }}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Box>

          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            sx={{
              bgcolor: "#347B89",
              height: "40px",
              borderRadius: "8px",
              px: 4,
              "&:hover": { bgcolor: "#205964" },
            }}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Submit"
            )}
          </Button>

          <Button
            variant="outlined"
            onClick={handleReset}
            sx={{ height: "40px", borderRadius: "8px" }}
          >
            Reset
          </Button>

          <Button
            variant="contained"
            onClick={handleDownloadExcel}
            sx={{
              bgcolor: "#1D6F42",
              height: "40px",
              borderRadius: "8px",
              "&:hover": { bgcolor: "#145231" },
            }}
          >
            Excel Report
          </Button>
        </Stack>
        <TableContainer
          sx={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <OngoingServiceCard
                  style={{
                    background: "#a6b4be",
                    color: "#000000ff",
                    borderRadius: "8px 10px 0 0",
                  }}
                >
                  <CardContent
                    style={{ flex: 0.5, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Sr. No</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 1.5, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Transaction ID</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 1, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Amount</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 1.5, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Date</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 1, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Status</Typography>
                  </CardContent>
                  <CardContent style={{ flex: 0.5 }}>
                    <Typography variant="subtitle2">Action</Typography>
                  </CardContent>
                </OngoingServiceCard>
              </TableRow>
            </TableHead>

            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  mt: 10,
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <TableBody>
                {onServices.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={6}
                      align="center"
                      sx={{ border: "none", mt: 2 }}
                    >
                      <Typography variant="body1">
                        No Transactions Found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  onServices
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={row.paytr_id} sx={{ border: "none" }}>
                        <OngoingServiceCard
                          sx={{ display: "flex", height: "3.5rem" }}
                        >
                          {/* Sr No */}
                          <CardContent sx={{ flex: 0.5 }}>
                            <Typography variant="body2">
                              {index + 1 + page * rowsPerPage}
                            </Typography>
                          </CardContent>

                          {/* Transaction ID */}
                          <CardContent sx={{ flex: 1.5 }}>
                            <Typography variant="body2" fontWeight="600">
                              {row.transaction_id}
                            </Typography>
                          </CardContent>

                          {/* Amount */}
                          <CardContent sx={{ flex: 1 }}>
                            <Typography variant="body2">
                              ₹{row.amount}
                            </Typography>
                          </CardContent>

                          {/* Added Date */}
                          <CardContent sx={{ flex: 1.5 }}>
                            <Typography variant="body2">
                              {new Date(row.added_date).toLocaleDateString()}
                            </Typography>
                          </CardContent>

                          {/* Status */}
                          <CardContent sx={{ flex: 1 }}>
                            <Chip
                              label={row.transfer_status}
                              size="small"
                              color={
                                row.transfer_status === "SUCCESS"
                                  ? "success"
                                  : "warning"
                              }
                              variant="outlined"
                            />
                          </CardContent>

                          {/* Action */}
                          <CardContent
                            sx={{
                              flex: 0.5,
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Button
                              variant="contained"
                              size="small"
                              sx={{
                                textTransform: "none",
                                backgroundColor: "#a6b4be",
                                "&:hover": { backgroundColor: "#8e9ea8" },
                              }}
                              onClick={() => handleView(row)}
                            >
                              View
                            </Button>
                          </CardContent>
                        </OngoingServiceCard>
                      </TableRow>
                    ))
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>

        <TablePagination
          sx={{ overflowY: "hidden" }}
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        <Modal open={openViewModal} onClose={handleCloseViewModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "95%",
              height: "90vh",
              bgcolor: "background.paper",
              borderRadius: "12px",
              boxShadow: 24,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {/* APP BAR */}
            <AppBar
              position="static"
              sx={{
                backgroundColor: "#347B89",
              }}
            >
              <Stack direction="row" alignItems="center" px={2}>
                <Typography sx={{ flexGrow: 1, fontWeight: 600 }}>
                  Transaction Details
                </Typography>
                <IconButton color="inherit" onClick={handleCloseViewModal}>
                  <CloseIcon />
                </IconButton>
              </Stack>
            </AppBar>

            {/* MODAL BODY */}
            <Box sx={{ p: 3, overflowY: "auto" }}>
              {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
                  <CircularProgress />
                </Box>
              ) : (
                <ViewPayouReportsModal data={modalData} />
              )}
            </Box>
          </Box>
        </Modal>
      </Box>
      <Footer />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default PaymentpayoutReport;
